import { CustomerPortalRequestMessage } from "../../../api/models/unified";
import { RequestAttachments } from "../../../components";
import { renderDateTime } from "../../../helpers/dayjsHeleprs";

interface RequestMessageProps {
  message: CustomerPortalRequestMessage;
}

const RequestMessage = ({ message }: RequestMessageProps) => {
  const userFullName = message.contactPersonFullName ?? message.userFullName;

  const fromLoggedUser = !!message.contactPersonFullName;

  return (
    <div
      className={`${fromLoggedUser ? "justify-self-end" : "justify-self-start"} mb-3.5 max-w-[75%]`}
    >
      <div className="bg-gray50 flex flex-col rounded-lg p-6 text-base/[24px] whitespace-pre-wrap italic">
        <div>{message.message}</div>
        {message.attachments.length > 0 && (
          <div className="mt-4">
            <RequestAttachments attachments={message.attachments} />
          </div>
        )}
      </div>
      <div
        className={`mt-1.5 text-[14px]/[16px] font-bold ${fromLoggedUser ? "text-right" : "text-primary text-left"}`}
      >
        <span>{renderDateTime(message.created)}</span>
        <span className="mx-1.5">•</span>
        <span>{userFullName}</span>
      </div>
    </div>
  );
};

export default RequestMessage;
